import { FormEventHandler } from "react";
import { Control } from "react-hook-form";
import { Modals } from "..";
import { Buttons } from "../../../atoms/Buttons";
import { InputTextarea } from "../../../atoms/Inputs/InputTextarea";
import { ControlTextArea } from "../../../atoms/controls/ControlTextArea";

interface ModalCommentProps {
  setModalShow: () => void;
  control: Control;
  formId: string;
  onSubmit: FormEventHandler;
  register: any;
}

const ModalComment = ({
  setModalShow,
  control,
  formId,
  onSubmit,
  register,
}: ModalCommentProps) => {
  return (
    <Modals
      modalTitle="코멘트 작성"
      setModalShow={setModalShow}
      modalCloseButton={true}
      modalButtons={
        <div
          style={{
            width: "auto",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            gap: "6px",
          }}
        >
          <Buttons
            type="submit"
            size="md"
            layout="primary"
            label="저장"
            form={formId}
          />
          <Buttons
            type="button"
            size="md"
            layout="cancelModal"
            label="취소"
            onClick={setModalShow}
          />
        </div>
      }
    >
      <form id={formId} onSubmit={onSubmit}>
        <ControlTextArea
          id="commentTextArea"
          control={control}
          name="steComment"
          direction="column"
          height={200}
          size="lg"
        />
      </form>
    </Modals>
  );
};

export default ModalComment;
